export default "__VITE_ASSET__DkYTzrcM__"